export function createNestedObjectWithValues(data) {
    let obj = {};

    Object.entries(data).forEach(([path, value]) => {
        let parts = path.split(".");
        let current = obj;

        parts.forEach((part, index) => {
            if (!current[part]) {
                current[part] = index === parts.length - 1 ? value : {};
            }
            current = current[part];
        });
    });

    return obj;
}